<template>
  <div class="car-wrap">
    <img src="../assets/img/car-banner.png" alt="" class="big-img">
    <div class="car-list">
      <p class="title">租车服务</p>
      <ul class="list">
        <li class="item" v-for="(item, index) in carList" :key="index">
          <div class="img-box">
            <img :src="item.img" class="car-img" alt="">
          </div>
          <div class="car-info">
            <p class="car-name">{{ item.name }}</p>
            <p class="monthly-rent"><span>{{ item.price }}元起/天</span></p>
            <p class="consult">
              <span @click="showPop = true; popType = 1;">预约咨询</span>
            </p>
          </div>
        </li>
      </ul>
    </div>
    <div class="page-info">
      <el-pagination background layout="prev, pager, next" :page-size="8" :pager-count="5" :total="total" @current-change="handleChange">
      </el-pagination>
    </div>
    <div class="pop-wrap" v-if="showPop">
      <div class="pop-main" :class="popType==2?'pop-main-1':''">
        <div class="close-btn" @click="showPop = false;"></div>
        <p class="title">{{ popType == 1 ? '预留联系方式' : '预留信息成功' }}</p>
        <div class="user-info" v-if="popType == 1">
          <div class="item">
            <p class="label">姓名：</p>
            <el-input class="input" maxLength="20" v-model="formInline.username" clearable></el-input>
          </div>
          <div class="item">
            <p class="label">手机号：</p>
            <el-input class="input" type="number" v-model="formInline.mobile" maxlength="11" @input="formInline.mobile = formInline.mobile.slice(0, 11)" clearable></el-input>
          </div>
          <div class="item">
            <p class="label">取车地点：</p>
            <el-cascader size="large" :options="options" v-model="selectedOptions">
            </el-cascader>
            <el-input class="input ipt-l" maxLength="20" v-model="formInline.address" clearable placeholder="请输入具体位置"></el-input>
          </div>
          <div class="item">
            <p class="label">用车时间：</p>
            <el-date-picker v-model="dateRange"
          :clearable="false"
          size="small"
          type="datetimerange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
          </div>
        </div>
        <div v-else>
          <p class="tips"> 已收到您的申请信息，稍后会安排客服经理与您对接，请稍作等待！</p>
        </div>
        <div class="submit-btn-box">
          <el-button type="primary" class="btn" :loading="btnLoading" @click="handleSubmit">{{ popType == 1 ? '提交资料' :
            '我知道了'}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import car from '@/assets/js/car.js'
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
export default {
  data() {
    return {
      carList: [],
      total: car.length,
      showPop: false,
      popType: 1, // 1 预留联系方式 2 预留信息成功
      formInline: {
        username: '',
        mobile: ''
      },
      btnLoading: false,
      options: regionData,
      selectedOptions: [],
      dateRange:[],
      pickerOptions: {
        // onPick: ({ maxDate, minDate }) => {
        //   if (minDate && this.pickerMinDate) {
        //     this.pickerMinDate = null;
        //   } else if (minDate) {
        //     this.pickerMinDate = minDate.getTime();
        //   }
        // },
        // disabledDate: (time) => {
        //   if (this.pickerMinDate) {
        //     return (time.getTime() > (this.pickerMinDate + this.day30)) || (time.getTime() < (this.pickerMinDate - this.day30));
        //   }
        //   return false;
        // }
	    },
    }
  },
  mounted() {
    this.carList = car.slice(0, 8);
  },
  methods: {
    handleAreaChange(value) {
      // value 是数组，如 ["330000", "330100", "330106"]
      // 可通过 CodeToText 转换为中文名称
      // const areaName = [
      //   CodeToText[value[0]],
      //   CodeToText[value‌:ml-citation{ref="1" data="citationList"}],
      //   CodeToText[value‌:ml-citation{ref="2" data="citationList"}]
      // ].filter(n => n).join('/');
      // console.log('选中地区：', areaName);
    },
    handleChange(val) {
      this.carList = car.slice((val - 1) * 8, val * 8);
    },
    handleSubmit() {
      
      if (this.popType == 1) {
        if (!this.formInline.username) {
          return this.$message.error('请输入姓名');
        }
        // 校验手机号是否为11位数字
        if (!/^1[3456789]\d{9}$/.test(this.formInline.mobile)) {
          return this.$message.error('请输入正确的手机号');
        }
        if(this.selectedOptions.length==0){
          return this.$message.error('请选择取车地点')
        }
        if(!this.formInline.address){
          return this.$message.error('请输入具体位置')
        }
        if(this.dateRange.length == 0){
          return this.$message.error('请选择用车时间')
        }
        this.btnLoading = true;
        setTimeout(() => {
          this.popType = 2;
          this.btnLoading = false;
        }, 500)
      } else {
        this.showPop = false;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.car-wrap {
  padding-bottom: 60px;

  .big-img {
    display: block;
    width: 100%;
  }

  .car-list {
    width: 870px;
    margin: 0 auto;

    .title {
      font-size: 24px;
      color: #1b1b1b;
      padding: 35px 0;
      text-align: center;
      line-height: 30px;
      font-weight: bold;
    }

    .list {
      display: flex;
      flex-wrap: wrap;
      column-gap: 10px;
      row-gap: 20px;
      min-height: 500px;

      .item {
        width: 210px;
        height: 240px;
        box-sizing: border-box;
        border-radius: 8px;
        overflow: hidden;

        &:hover {
          box-shadow: 0px 0px 12px 0px #f0f0f0;
        }

        .img-box {
          padding: 0 15px;
          height: 130px;
          display: flex;
          justify-content: center;
          align-items: center;

          .car-img {
            max-width: 100%;
            max-height: 100%;
          }
        }

        .car-info {
          padding: 0 15px;
          margin-top: 5px;

          .car-name {
            max-height: 36px;
            font-size: 14px;
            line-height: 18px;
            color: #1b1b1b;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            /* 限制显示 2 行 */
            -webkit-box-orient: vertical;
            /* 设置垂直排列 */
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .monthly-rent {
            font-size: 11px;
            color: #ff2c31;
            line-height: 14px;
            margin-top: 13px;

            span {
              font-size: 14px;
              font-weight: 600;
            }
          }

          .total-prices {
            color: #7d7d7d;
            font-size: 11px;
            line-height: 12px;
            margin: 10px 0 12px;
          }

          .consult {
            color: #5097ff;
            font-size: 11px;
            text-decoration: underline;

            span {
              display: inline-block;
              cursor: pointer;
              line-height: 28px;
            }
          }
        }
      }
    }
  }

  .page-info {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
}

.pop-wrap {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;

  .pop-main {
    width: 760px;
    background-color: #ffffff;
    border-radius: 8px;
    padding: 60px 90px;
    box-sizing: border-box;
    text-align: center;

    position: relative;
    &.pop-main-1{
      width: 800px;
    }
    .close-btn {
      width: 40px;
      height: 40px;
      position: absolute;
      right: 0;
      top: 0;
      z-index: 5;
      cursor: pointer;
      background: url("../assets/img/close.png") no-repeat center center;
      background-size: 14px 14px;
    }

    .title {
      font-size: 30px;
      color: #000000;
      line-height: 32px;
      font-weight: 600;
    }

    .tips {
      font-size: 20px;
      color: #0f1b20;
      line-height: 32px;
      margin: 35px 0;
    }

    .btn {
      width: 273px;
      height: 60px;
      background-color: #5097ff;
      border-radius: 8px;
      color: #fff;
      font-size: 20px;
      cursor: pointer;
    }

    .user-info {
      margin: 40px 0;

      .item {
        display: flex;
        align-items: center;
        margin: 10px 0;
        &:nth-of-type(1) {
          margin-bottom: 20px;
        }

        .label {
          width: 100px;
          font-size: 18px;
          color: #1b1b1b;
        }

        .input {
          flex: 1;
          &.ipt-l{
            margin-left: 10px;
          }
        }
      }
    }
  }
}
</style>